import {
    FETCH_LOCATION_DATA,
    FETCH_LOCATIONS_DATA,
    INITIAL_LOCATION_STATE_DATA,
    UPDATE_LOCATION_STATE,
    UPDATE_LOCATION_STATE_FILTERS,
    DELETE_MULTIPLE_LOCATIONS
} from "../actions/types"

const initial = {
    building: "",
    floor: "",
    deleteUnitId: "",
    unitDescription: "",
    descriptionError: "",
    deleteUnitName: "",
    room: "",
    addBuilding: "",
    addFloor: "",
    addRoom: "",
    buildingId: "",
    floorId: "",
    roomId: "",
}
const INITIAL_STATE = {
    downloadLocationData:[],
    locationData: [],
    allPagination: {
        currentPage: 1,
        totalPages: 0,
        totalCount: 0
    },
    locationParams: {},
    initialState: {
        building: "",
        floor: "",
        deleteUnitId: "",
        unitDescription: "",
        descriptionError: "",
        deleteUnitName: "",
        room: "",
        addBuilding: "",
        addFloor: "",
        addRoom: "",
        buildingId: "",
        floorId: "",
        roomId: ""
    },
    searchLocation: ""
}
let calculateTotalPages = (totalCount, pageSize) => {
    return (totalCount && pageSize) ? (Math.floor(totalCount / pageSize) + (totalCount % pageSize ? 1 : 0)) : 1
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_LOCATIONS_DATA:
            return {
                ...state,
                locationData: action.payload.hasOwnProperty('results') ? action.payload.results : action.payload,
                allPagination: {
                    currentPage: action.payload.current_page,
                    totalPages: calculateTotalPages(action.payload.total_count, action.payload.page_size),
                    totalCount: action.payload.total_count
                },
                locationParams: action.param
            }
        case FETCH_LOCATION_DATA:
            return {
                ...state,
                downloadLocationData: action.payload.hasOwnProperty('locationData') ? action.payload.locationData : action.payload
            }
        case INITIAL_LOCATION_STATE_DATA:
            return {
                ...state,
                initialState: initial,
                searchLocation: ""
            }
        case UPDATE_LOCATION_STATE:
            return {
                ...state,
                searchLocation: action.payload,
                initialState: initial
            }
        case DELETE_MULTIPLE_LOCATIONS:
            return {
                ...state,
                downloadLocationData: [...state.downloadLocationData.filter( val=> !action.payload.data.includes(val.location_id))]
            }
        case UPDATE_LOCATION_STATE_FILTERS:
            let event = action.payload
            if (event.target.name === "building" || event.target.name === "addBuilding") {
                state.initialState = {
                    ...state.initialState,
                    [event.target.name]: event.target.value,
                    buildingId: event.target.selectedOptions[0].id,
                }
            }
            else if (event.target.name === "floor" || event.target.name === "addFloor") {
                state.initialState = {
                    ...state.initialState,
                    [event.target.name]: event.target.value,
                    floorId: event.target.selectedOptions[0].id,
                }
            }
            else if (event.target.name === "room" || event.target.name === "addRoom") {
                state.initialState = {
                    ...state.initialState,
                    [event.target.name]: event.target.value,
                    roomId: event.target.selectedOptions[0].id,
                }
            }
            return {
                ...state,
                initialState: state.initialState,
                searchLocation: ""
            }
        default:
            return state;
    }
}